/**
 * StageProgramScreen — the bought stage programme, which the family adapts in one sentence.
 *
 * Route `stage-program` (parent space only): the home row of the stage programme and the stage
 * mails lead here. Data pattern B: `useStageProgramData` reads, `useStageProgramState` holds the
 * sheet and the recomposition, the view-model groups the séances by day.
 */
import { useSelector } from "react-redux"

import { StageProgramPage } from "../../../../../../design-system"
import { stageProgramViewModel } from "../../../../view-models/parent/StageProgram/stageProgramViewModel"
import { useStageProgramData } from "./useStageProgramData"
import { useStageProgramState } from "./useStageProgramState"

export function StageProgramScreen() {
    const data = useStageProgramData()
    const { ui, program, canRecompose, actions } = useStageProgramState(data.raw, data.retry)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => stageProgramViewModel(state, program, ui.newChapterIds))

    return (
        <StageProgramPage
            program={vm}
            loading={data.loading}
            error={data.raw == null ? data.error : null}
            onRetry={data.retry}
            notice={ui.notice}
            onClose={actions.close}
            onAdapt={actions.openSheet}
            onReset={actions.reset}
            recomposing={ui.recomposing}
            recomposeDone={ui.pending != null}
            onRecomposeFinished={actions.reveal}
            sheet={{
                visible: ui.sheetOpen,
                onClose: actions.closeSheet,
                draft: ui.draft,
                onChangeDraft: actions.setDraft,
                onAddExample: actions.addExample,
                onRecompose: actions.recompose,
                canRecompose,
                errorMessage: ui.errorMessage,
            }}
        />
    )
}

export default StageProgramScreen
